import { defineStore } from 'pinia'

export interface UiState {
  showTimeKeeper: boolean,
  showSplitTimes: boolean,
  showFinishTopBox: boolean,
  showTrainingLayout: boolean,
  isTraining: boolean,
  slipStreamSeconds: string,
  inSlipStream: boolean,
  hideSlipStreamWarning: boolean
}

const initialState = () => ({
  showTimeKeeper: false,
  showSplitTimes: false,
  showFinishTopBox: false,
  showTrainingLayout: false,
  isTraining: false,
  slipStreamSeconds: '0.0',
  inSlipStream: false,
  hideSlipStreamWarning: false
})

export const uiState = defineStore('uiState', {
  state: initialState
})

